import { ReducerState, ReducerAction, ActionType } from "./UpTypes";

function uploadStateHandler(
  state: ReducerState,
  action: ReducerAction
): ReducerState {
  const { type } = action;
  switch (type) {
    case "Reset":
      return {
        errorRecords: [],
        recordsCount: 0,
        completedRecordsCount: 0,
      };
    case "Initialize":
      return {
        errorRecords: [],
        recordsCount: action.param,
        completedRecordsCount: 0,
      };
    case "AddRecord":
      return {
        ...state,
        recordsCount: state.recordsCount + action.param,
      };
    case "CompleteRecord":
      return {
        ...state,
        completedRecordsCount: state.completedRecordsCount + 1,
      };
    case "AddError":
      return {
        ...state,
        errorRecords: [...state.errorRecords, action.param],
      };
    default:
      return state;
  }
}

const uploadStateInitialize: ReducerState = {
  errorRecords: [],
  recordsCount: 0,
  completedRecordsCount: 0,
};

export { uploadStateHandler, uploadStateInitialize };
